// A small round country flag for a language (S113): SVG, because emoji flags do not render on
// Windows. English shows the United Kingdom's flag (the UI's English is British).
import type { Locale } from "../i18n";
import { cn } from "./cn";

function UnitedKingdom() {
  return (
    <>
      <rect width="60" height="30" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="2.5" />
      <path d="M30,0 V30 M0,15 H60" stroke="#fff" strokeWidth="10" />
      <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
    </>
  );
}

function France() {
  return (
    <>
      <rect width="20" height="30" fill="#002654" />
      <rect x="20" width="20" height="30" fill="#fff" />
      <rect x="40" width="20" height="30" fill="#CE1126" />
    </>
  );
}

function Spain() {
  return (
    <>
      <rect width="60" height="30" fill="#AA151B" />
      <rect y="7.5" width="60" height="15" fill="#F1BF00" />
    </>
  );
}

const FLAGS: Record<Locale, () => React.JSX.Element> = { en: UnitedKingdom, fr: France, es: Spain };

/** The flag in a circle of `size` pixels; decorative (the language's name says it). */
export function Flag({ locale, size = 18, className }: { locale: Locale; size?: number; className?: string }) {
  const Shape = FLAGS[locale];
  return (
    <svg
      viewBox="15 0 30 30"
      width={size}
      height={size}
      aria-hidden
      className={cn("shrink-0 rounded-full ring-1 ring-black/10 dark:ring-white/20", className)}
      data-flag={locale}
    >
      <clipPath id={`flag-${locale}`}>
        <circle cx="30" cy="15" r="15" />
      </clipPath>
      <g clipPath={`url(#flag-${locale})`}>
        <Shape />
      </g>
    </svg>
  );
}
